import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './index.scss'
import './common.css'
import reportWebVitals from './reportWebVitals'
import LoginPage from './login'
import WorkflowsPage from './workflows'
import WorkflowOverviewPage from './workflows/overview/overview'
import WorkflowEditPage from './workflows/edit/edit'
import WorkflowStepPage from './steps'
import ReviewRowPage from './steps/review/row'
import StepViewPage from './steps/view'
import AdminPage from './admin'
import AccountPage from './account'
import ReportingPage from './workflows/report'
import DuplicatesPage from './workflows/duplicates'

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <Routes>
                <Route path='/' element={<WorkflowsPage />} />
                <Route path='/login' element={<LoginPage />} />
                <Route path='/admin' element={<AdminPage />} />
                <Route path='/account' element={<AccountPage />} />
                <Route path='/workflows' element={<WorkflowsPage />} />
                <Route path='/workflows/:id' element={<WorkflowOverviewPage />} />
                <Route path='/workflows/:id/reporting' element={<ReportingPage />} />
                <Route path='/workflows/:id/duplicates' element={<DuplicatesPage />} />
                <Route path='/workflows/:id/edit' element={<WorkflowEditPage />} />
                <Route path='/workflows/:id/steps/:stepIndex' element={<WorkflowStepPage />}>
                    <Route path='view/:rowId' element={<StepViewPage />} />
                    <Route path='view/:rowId/:srcId' element={<StepViewPage />} />
                    <Route path='review/:user/:rowId' element={<ReviewRowPage />} />
                    <Route path='review/:user/:rowId/:srcId' element={<ReviewRowPage />} />
                </Route>
            </Routes>
        </Router>
    </React.StrictMode>,
    document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
